import { useContext } from "react";
import { FormContext } from "../../../context/FormContext";
import { ToolContext } from "../../../context/ToolContext";
import { Asset } from "../../../model/viewModel/asset";
import { findShapeAnnotation, updateShapeAnnotationDirectly } from "../../../app/networkSlice";
import { useDispatch, useSelector } from "react-redux";
import { DEFAULT_ANNOTATION_COLOR } from "../../../constants/colors";

const useShapeAnnotationForm = () => {
  const dispatchRedux = useDispatch();
  const { formState, dispatch } = useContext(FormContext);
  const { toolState } = useContext(ToolContext);
  const { clickedAsset } = toolState as { clickedAsset?: Asset };
  const { clientSettings } = formState;
  const debugEnabled = clientSettings.features.DebugEnabled;

  const shapeAnnotation = useSelector((state) =>
    findShapeAnnotation(state as any, clickedAsset?.id ?? ""),
  );

  const color =
    shapeAnnotation?.styles?.color ||
    formState?.shapeAnnotationProperties?.color ||
    DEFAULT_ANNOTATION_COLOR;

  const resetColor = () => {
    dispatch({
      form: "shapeAnnotationProperties",
      field: "color",
      value: DEFAULT_ANNOTATION_COLOR,
      type: "UPDATE_FIELD",
    });
  };

  const setColor = (color: string) => {
    dispatch({
      form: "shapeAnnotationProperties",
      field: "color",
      value: color,
      type: "UPDATE_FIELD",
    });

    if (shapeAnnotation) {
      dispatchRedux(
        updateShapeAnnotationDirectly({
          ...shapeAnnotation,
          styles: {
            ...shapeAnnotation.styles,
            color: color,
          },
        }),
      );
    }
  };

  return {
    color,
    setColor,
    resetColor,
    debugEnabled,
    clickedAsset,
  };
};

export default useShapeAnnotationForm;
